import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    generalBankAll: [],
    generalBank: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const generalBankSlice = createSlice({
    name: "generalBank",
    initialState,
    reducers: {
        setGeneralBankAll: (state, action) => {
            state.generalBankAll = action.payload;
        },
        setGeneralBank: (state, action) => {
            state.generalBank = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const { 
    setGeneralBankAll, 
    setGeneralBank, 
    setCurrentPage, 
    setTotalPages, 
    setRowsPerPage 
} = generalBankSlice.actions;

export default generalBankSlice.reducer;
